<div class="component-container mat-typography mat-body mat-app-background">
  <mat-accordion>

    @if (retrievedInfo && someAppsSubmitted) {
      @for (app of retrievedInfo.searchedApplications; track trackByAppId($index, app)) {
        @if (app.portalApplicationStatus === 'SUBMITTED') {
          <mat-expansion-panel>
            <mat-expansion-panel-header [expandedHeight]="'60px'" [collapsedHeight]="'60px'">
              <mat-panel-title>
                <div>{{app.productDescription}}</div>
                <div>{{app.applicationTrackingId}}</div>
                <div>{{app.combinedStatus}}</div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <section class="panel-content">
              <div class="give-me-some-space around section-1">
                <div class="header-and-print">
                  <div class="header"><h2>Application Details</h2></div>
                  <div class='view-app' (click)="retrieveApp(app.applicationTrackingId)">
                    VIEW APPLICATION
                  </div>
                  <div><app-print-button></app-print-button></div>
                </div>
                <div class="app-info-and-member-services">
                  <section class="app-info">
                    <div class="content-row">
                      <div class="app-info-label">
                        <span>Current Status</span>
                      </div>
                      <div class="app-info-value">
                        <span>{{app.downstreamTrackingStatus}}</span>
                      </div>
                    </div>
                    <div class="content-row">
                      <div class="app-info-label">
                        <span>Application Submission Number</span>
                      </div>
                      <div class="app-info-value">
                        <span>{{app.applicationTrackingId}}</span>
                      </div>
                    </div>
                    <div class="content-row">
                      <div class="app-info-label">
                        <span>Submitted On</span>
                      </div>
                      <div class="app-info-value">
                        <span>{{app.creationDate | date:'MM/dd/yyyy'}}</span>
                      </div>
                    </div>
                  </section>
                  <section class="member-info-container">
                    @if (content.appStatusContentOne) {
                      <div class="member-info">
                        <span>{{content.appStatusContentOne}}</span>
                      </div>
                    }
                  </section>
                </div>
              </div>
              @if (content.appStatusContentTwo) {
                <div class="give-me-some-space above around plan-documents-section">
                  <span>{{content.appStatusContentTwo}}</span>
                </div>
              }
              @if (content.appStatusContentThree) {
                <div class="give-me-some-space above around disclaimer-section">
                  <span>{{content.appStatusContentThree}}</span>
                </div>
              }
            </section>
          </mat-expansion-panel>
        }
      }
    } @else {
      <div class="no-data">
        <span>No Plans Submitted/Saved</span>
      </div>
    }

  </mat-accordion>
</div>
